export default {
  academicPeriod: {
    id: '',
    periodCode: '',
    year: null,
    semester: null,
  },
  academicPeriods: [],
  processing: false,
  error: null,
  success: null,
}



